import gql from 'graphql-tag';
import SUPPORT_CATEGORY_FRAGMENT from '../fragments/support-category';

const GET_ALL_SUPPORT_CATEGORIES = gql`
  query getAllSupportCategories {
    supportCategories {
      ...BaseSupportCategory
    }
  }
  ${SUPPORT_CATEGORY_FRAGMENT}
`;

export default GET_ALL_SUPPORT_CATEGORIES;
